var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.025 50.5986C44.6054 57.1093 34.0893 57.2831 27.4628 50.9399C20.7741 44.5368 20.5404 33.8863 26.9435 27.1977C43.4344 9.97024 59.2695 17.7119 59.2695 17.7119C47.6363 6.57524 29.1117 6.98074 17.977 18.614C12.4097 24.4316 9.72641 31.9705 9.88985 39.4474C10.0533 46.9243 13.0635 54.3391 18.8791 59.9064C30.4585 70.9893 48.861 70.6396 60.0143 59.1657L51.025 50.5986Z",
    fill: "#005B8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.025 50.5986C44.6054 57.1093 34.0893 57.2831 27.4628 50.9399C20.7741 44.5368 20.5404 33.8863 26.9435 27.1977C43.4344 9.97024 59.2695 17.7119 59.2695 17.7119C47.6363 6.57524 29.1117 6.98074 17.977 18.614C12.4097 24.4316 9.72641 31.9705 9.88985 39.4474C10.0533 46.9243 13.0635 54.3391 18.8791 59.9064C30.4585 70.9893 48.861 70.6396 60.0143 59.1657L51.025 50.5986Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5752 27.6452L60.5686 19.0801C60.1444 18.6187 59.7058 18.1677 59.2465 17.727C53.431 12.1597 45.89 9.47641 38.4131 9.63985C30.9362 9.80329 23.5214 12.8135 17.9541 18.6291C6.81743 30.2623 7.22292 48.7869 18.8561 59.9215C18.8561 59.9215 10.4297 44.4402 26.9206 27.2128C33.3237 20.5241 43.9742 20.2904 50.6628 26.6935C50.9835 27.0017 51.2856 27.3204 51.5752 27.6452Z",
    fill: "#005B8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5752 27.6452L60.5686 19.0801C60.1444 18.6187 59.7058 18.1677 59.2465 17.727C53.431 12.1597 45.89 9.47641 38.4131 9.63985C30.9362 9.80329 23.5214 12.8135 17.9541 18.6291C6.81743 30.2623 7.22292 48.7869 18.8561 59.9215C18.8561 59.9215 10.4297 44.4402 26.9206 27.2128C33.3237 20.5241 43.9742 20.2904 50.6628 26.6935C50.9835 27.0017 51.2856 27.3204 51.5752 27.6452Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9813 42.2542C65.204 39.1116 65.7916 35.5449 65.5226 31.8147C64.6247 32.5099 63.702 33.1616 62.7607 33.7657C61.6932 29.9631 59.6243 26.4192 56.5996 23.5352C59.6946 28.306 60.4084 33.4905 59.5726 37.8951C60.1684 37.6634 60.7601 37.4131 61.3456 37.1441C61.3146 40.115 60.6422 42.9866 59.4236 45.5582C60.1291 45.583 60.8387 45.5872 61.5504 45.5727C60.8242 48.9967 59.2374 52.3606 56.6948 55.3025C61.4056 52.191 64.9578 47.3519 66.5715 41.5529C65.7109 41.8198 64.8482 42.0535 63.9813 42.2542Z",
    fill: "#CB5828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9813 42.2542C65.204 39.1116 65.7916 35.5449 65.5226 31.8147C64.6247 32.5099 63.702 33.1616 62.7607 33.7657C61.6932 29.9631 59.6243 26.4192 56.5996 23.5352C59.6946 28.306 60.4084 33.4905 59.5726 37.8951C60.1684 37.6634 60.7601 37.4131 61.3456 37.1441C61.3146 40.115 60.6422 42.9866 59.4236 45.5582C60.1291 45.583 60.8387 45.5872 61.5504 45.5727C60.8242 48.9967 59.2374 52.3606 56.6948 55.3025C61.4056 52.191 64.9578 47.3519 66.5715 41.5529C65.7109 41.8198 64.8482 42.0535 63.9813 42.2542Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9818 42.2559C65.2045 39.1133 65.7921 35.5466 65.5231 31.8164C64.9501 40.3567 61.2178 43.5613 59.4241 45.5599C60.1296 45.5847 60.8392 45.5888 61.5509 45.5743C60.8248 48.9983 59.2379 52.3623 56.6953 55.3042C61.4061 52.1926 64.9583 47.3536 66.5721 41.5545C65.7114 41.8214 64.8487 42.0552 63.9818 42.2559Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.4199,
    y1: 18.1598,
    x2: 59.7214,
    y2: 59.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2408,
    stopColor: "#161113",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161113",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.266,
    y1: 16.4619,
    x2: 41.0845,
    y2: 41.2724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 61.5865,
    y1: 55.3035,
    x2: 61.5865,
    y2: 23.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7977,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 61.6343,
    y1: 31.8166,
    x2: 61.6343,
    y2: 55.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161113",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161113",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.86196206258c0eb1ef6d4f678f8daa9c.svg";
export { ForwardRef as ReactComponent };